export enum DEVICES_DIMENS {
  MOBILE = 480,
  TABLET = 1024,
}
